import React from "react";

const DataTableInfo = ({ numberPerPage, totalItems }) => {
  return (
    <div
      className="dataTables_info"
      id="kt_table_1_info"
      role="status"
      aria-live="polite"
    >
      Affichage de 1 à {numberPerPage} sur {totalItems} données
    </div>
  );
};

export default DataTableInfo;
